module.exports = __webpack_public_path__ + "img/planeas_10_7.da644aa5.png";